import React from 'react';
import { Link } from "react-router-dom"

const Footer = ({ setStage, stage, onSendTemplate }) => {
  const handleNext = () => {
    if (stage > 0 && stage < 2) {
      setStage(stage + 1);
    }
    else {
      setStage(1)
    }
  }

  const handlePrevious = () => {
    if (stage > 1 && stage < 4) {
      setStage(stage - 1);
    }
  }


  return (
    <div className="mt-auto bg-gray-50 border-t border-gray-200 px-6 py-4">
      <div className="flex justify-between items-center max-w-full">
        {stage == 1 ? (
          <Link to="/Template">
            <button className="px-4 py-2 border border-gray-300 
        rounded-md text-gray-700 bg-white hover:bg-gray-50 transition-colors duration-200 font-medium"
              onClick={handlePrevious}
            >
              Discard
            </button>
          </Link>) : (
          <button className="px-4 py-2 border border-gray-300 
        rounded-md text-gray-700 bg-white hover:bg-gray-50 transition-colors duration-200 font-medium"
            onClick={handlePrevious}
          >
            Previous
          </button>
        )}

        {stage == 2 ? (
          <button className="px-6 py-2 bg-blue-400 text-white rounded-md hover:bg-blue-500
         transition-colors duration-200 font-medium"
            onClick={onSendTemplate}
          >
            Submit for Review
          </button>) : (
          <button className="px-6 py-2 bg-blue-400 text-white rounded-md hover:bg-blue-500
         transition-colors duration-200 font-medium"
            onClick={handleNext}
          >
            Next
          </button>
        )}

      </div>
    </div>
  );
}

export default Footer;
